import popupKey from './helpers/popupKey';
import actions from './actions';

export const showNotification = (key, value, popup) => ({
  type: actions.SHOW_NOTIFICATION,
  key: popup ? popupKey(key) : key,
  value,
  popup
});
export const hideNotification = (key, popup) => ({
  type: actions.HIDE_NOTIFICATION,
  key: popup ? popupKey(key) : key
});
